// @flow

import type { CookieType }          from '../../config/cookiesConfig';
import cookiesConfig                from '../../config/cookiesConfig';
import { selectUserCookieSettings } from '../../selectors/cookieSettingsSelectors';
import type { State }               from '../../store';
import getCookieTypeConfigHash      from './getCookieTypeConfigHash';

const isStorageAllowed = (cookieType: CookieType, state: State): boolean => {

  // If required, always return true
  if (cookiesConfig[cookieType].required) {
    return true;
  }

  const userCookieSettings = selectUserCookieSettings(state);

  return userCookieSettings.getIn([cookieType, 'configHash'], '') === getCookieTypeConfigHash(cookieType)
    && userCookieSettings.getIn([cookieType, 'enabled'], false);
};


export default isStorageAllowed;



// WEBPACK FOOTER //
// ./src/utils/cookieSettings/isStorageAllowed.js